import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { I18nProvider } from "@/i18n/I18nProvider";
import Portal from "@/pages/Portal";

function App() {
  return (
    <I18nProvider>
      <BrowserRouter>
        <Routes>
          <Route path="*" element={<Portal />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </I18nProvider>
  );
}

export default App;
